import React from "react";
import { Line } from "rc-progress";

function LineProgressBar({ complete, strokeWidth }) {
  return (
    <div
      style={{
        // display: "flex",
        height: "100%",
      }}
    >
      <Line
        percent={complete}
        trailColor="fff"
        strokeWidth={strokeWidth ? strokeWidth : "4"}
        style={{
          boxShadow: "0 0 20px 8px rgb(227 230 236 / 75%)",
          borderRadius: "80px 80px 80px 80px",
        }}
        strokeColor="#cfd12a"
      />
    </div>
  );
}

export default LineProgressBar;
